module.exports = __webpack_public_path__ + "static/media/Group1.87a8149f.png";